module.exports = __webpack_public_path__ + "static/media/Aggiungi.d45ae7c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/public/Aggiungi.png
// module id = 727
// module chunks = 0